import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Icon from "components/Elements/Icon/Icon";
import useOnClickOutside from "hooks/useOnClickOutside";
import { ButtonA } from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./subscribersOnlyIcon.module.scss";

const CONTAINER_WIDTH = 280;
const ARROW_SIZE = 10;

interface ISubscribersOnlyIconProps {
  titleKey: string;
  showPromoPopup: boolean;
  setShowPromoPopup: (value: boolean) => void;
  disabled?: boolean;
}

interface IPortalPopupProps {
  setShowPromoPopup: (value: boolean) => void;
  showPromoPopup: boolean;
  iconRef: React.RefObject<HTMLDivElement>;
  titleKey: string;
}

const PortalPopup = ({
  setShowPromoPopup,
  showPromoPopup,
  iconRef,
  titleKey,
}: IPortalPopupProps) => {
  const { getTextByKey, getDirection } = useContent();

  const [style, setStyle] = useState<{
    top?: string;
    left?: string;
    opacity?: number;
  }>({});

  const tooltipRef = useRef<HTMLDivElement>(null);

  const portalContainer = document.querySelector(".promo-popup-container");

  useEffect(() => {
    if (iconRef.current && tooltipRef.current) {
      const extraHeaderHight =
        document.querySelector(".black-friday-header")?.getBoundingClientRect()
          ?.height ||
        (!!document.querySelector(".black-friday-header-exist") ? 70 : 0);

      const iconRect = iconRef.current.getBoundingClientRect();

      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const tooltipHeight = tooltipRect.height || 200;

      setStyle({
        top: `${
          iconRect.top - tooltipHeight - ARROW_SIZE - extraHeaderHight
        }px`,
        left: `${iconRect.left + iconRect.width / 2 - CONTAINER_WIDTH / 2}px`,
        opacity: 1,
      });
    }
  }, [iconRef.current, showPromoPopup, tooltipRef]);

  useOnClickOutside(
    tooltipRef,
    () => {
      setShowPromoPopup(false);
    },
    true
  );

  return showPromoPopup && portalContainer
    ? createPortal(
        <div
          className={styles.tooltipContainer}
          style={style}
          ref={tooltipRef}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className={styles.close}
            onClick={() => setShowPromoPopup(false)}
          >
            <Icon name="x" gray />
          </button>
          <h3
            className={`${
              getDirection() === "rtl" ? `${styles.rtlTitle}` : ""
            }`}
          >
            {getTextByKey(titleKey)}
          </h3>
          {getTextByKey("feature-for-subscribers")}
          {/* @ts-ignore */}
          <ButtonA
            blank
            page="plans"
            title={getTextByKey("upgrade")}
            target="_blank"
          />
          <div className={styles.tooltipArrow}></div>
        </div>,
        portalContainer
      )
    : null;
};

const SubscribersOnlyIcon = ({
  titleKey,
  showPromoPopup,
  setShowPromoPopup,
  disabled,
}: ISubscribersOnlyIconProps) => {
  const iconRef = useRef<HTMLDivElement>(null);

  return (
    <button
      className={styles.container}
      onClick={(e) => {
        e.preventDefault();
        setShowPromoPopup(!showPromoPopup);
      }}
      disabled={disabled}
      ref={iconRef}
    >
      <Icon name="jm-marketing-icon" />
      <PortalPopup
        showPromoPopup={showPromoPopup}
        iconRef={iconRef}
        titleKey={titleKey}
        setShowPromoPopup={setShowPromoPopup}
      />
    </button>
  );
};

export default SubscribersOnlyIcon;
